import { render, staticRenderFns } from "./UserManageDetailTwo.vue?vue&type=template&id=20e1e67c&"
import script from "./UserManageDetailTwo.vue?vue&type=script&lang=js&"
export * from "./UserManageDetailTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports